export enum PayPeriodTypeEnum {
    Hourly = 1,
    Daily = 2,
    Shift = 3
}
